import React, { createContext, useState, useCallback, useContext } from 'react';

export const UIHelperContext = createContext({
  activeHelper: null,
  showHelper: () => {},
  hideHelper: () => {},
  hideAllHelpers: () => {},
});

export default function UIHelperProvider({ children }) {
  const [activeHelper, setActiveHelper] = useState(null);

  const showHelper = useCallback((helperConfig) => {
    setActiveHelper(helperConfig);
  }, []);

  const hideHelper = useCallback((helperId) => {
    if (!helperId || activeHelper?.id === helperId) {
      setActiveHelper(null);
    }
  }, [activeHelper]);

  const hideAllHelpers = useCallback(() => {
    setActiveHelper(null);
  }, []);

  const contextValue = {
    activeHelper,
    showHelper,
    hideHelper,
    hideAllHelpers,
  };

  return (
    <UIHelperContext.Provider value={contextValue}>
      {children}
    </UIHelperContext.Provider>
  );
}

export const useUIHelperContext = () => {
  const context = useContext(UIHelperContext);
  if (!context) {
    throw new Error('useUIHelperContext must be used within a UIHelperProvider');
  }
  return context;
};
